export default __webpack_public_path__ + "static/media/SWT1570.34I-37792_-22421_0.8cdd7609.jpg";